import { Injectable } from '@angular/core';

import { SiteTypeEnum } from '../../enums';
import { QuickRepliesElementsConfiguration } from '../../models';
import { StrategyAbstractService } from '../strategy-abstract.service';

@Injectable({
  providedIn: 'root',
})
export class Instagram2Service extends StrategyAbstractService {
  constructor() {
    super();
  }

  getType(): number {
    return 9; // alcmeon.db.Sites.TYPE_INSTAGRAM_FACEBOOK
  }
  getTypeString(): string {
    return SiteTypeEnum.Instagram2;
  }
  getAllTasksTypesForInbox(): number[] {
    return this.getAllTasksTypes();
  }
  getAllTasksTypes(): number[] {
    return [37, 38, 42, 30, 43];
  }
  getPublicTaskTypes(): number[] {
    // For favorites filtering
    return [30, 43];
  }
  getPrivateTaskTypes(): number[] {
    return [37, 38, 42];
  }
  getDefaultPrivateTaskType(): number {
    return 37;
  }
  getTaskTypeString(taskType: number): string {
    const mapping = {
      30: 'instagram/comments',
      31: 'instagram/mentions',
      37: 'instagram/private',
      38: 'instagram/story-mention',
      42: 'instagram/story-reply',
      43: 'instagram/live-comments',
    };
    return mapping[taskType];
  }

  getTaskTypeQueueId(taskType: number): string {
    const mapping = {
      30: 'insta-comments',
      31: 'insta-mentions',
      37: 'insta-private',
      38: 'insta-story-mention',
      42: 'insta-story-reply',
      43: 'insta-live-comments',
    };
    return mapping[taskType];
  }

  canHaveSurveys(): boolean {
    return true;
  }

  taskTypeHasPublicationFilter(taskType: number): boolean {
    return taskType === 30;
  }

  getQuickRepliesElementsConfig(): QuickRepliesElementsConfiguration {
    return {
      maxAnswerNb: 11,
      answerLabelMaxLength: 20,
      hasDescription: false,
      canHaveUserVariableInRootQuestion: false,
      hasPhoneEmailAnswerType: false,
      hasUrlAnswerType: false,
      hasTargetAppId: true,
      boxesCanBeTested: false,
      hasPersistentMenu: false,
      hasWelcomeMessage: false,
      imageMimeTypes: 'image/jpeg, image/png, image/ico, image/bmp',
      editorConfiguration: {
        fileEnabled: false,
        hasImageControl: false,
      },
      sendTextAfterButtonChoice: false,
      canSendVideo: true,
    };
  }

  mustCheckIfMessageDeleted(isPrivate: boolean): boolean {
    // Check if message is deleted if it is public
    return !isPrivate;
  }
}
